import React from 'react';
import { useTranslation } from '@blocs.i18n';
import { PrimaryButton } from '@minecraft.atoms';
import { usePaginationContext } from './PaginationContext';

const SeeMore = () => {
  const { t } = useTranslation();

  const { totalRecords, pageLimit, currentPage, onPageChanged } = usePaginationContext();
  return totalRecords > pageLimit * currentPage ? (
    <PrimaryButton
      variant="secondary"
      full
      onClick={(): void =>
        onPageChanged({
          currentPage: currentPage + 1,
          pageLimit,
        })
      }
      label={t('common:button.seeMore')}
    />
  ) : null;
};

export default SeeMore;
